<template>
  <s-label title="Environment" :type="color">
    <span data-testid="environment-label">{{ environment }}</span>
  </s-label>
</template>

<script>
  export default {
    name: 'EnvironmentLabel',
    props: ['env'],
    computed: {
      environment() {
        return this.env.toUpperCase();
      },
      color() {
        return {
          '-': 'secondary',
          DEV: 'secondary',
          DR: 'warning',
          POC: 'active',
          UAT: 'error',
          PROD: 'approved',
        }[this.environment];
      },
    },
  };
</script>
